<!-- Created by Alex Poh. on 20/04/20.-->
<!-- Copyright © 2020 Curriculum Ltd. All rights reserved.-->

<div class="curr-school-admin-dashboard">
  <div class="two-section-row">
    <div class="two-section-row-item m-b-24">
      <div class="dashboard-outside-title">
        <div class="title-text">Task List</div>
        <div class="title-actions">
          <curr-button class="add-new-tasks" variant="overflow" icon="cross" size="big" (click)="addNewTask()"
            >Add New</curr-button
          >
        </div>
      </div>
      <div class="dashboard-item-container">
        <curr-task-list #tasksList [showTitleSection]="false"></curr-task-list>
      </div>
    </div>
    <div class="two-section-row-item m-b-24">
      <div class="dashboard-outside-title">
        <div class="title-text">School Statistic</div>
      </div>

      <curr-school-statistic-school-admin
        *ngIf="!hasMultipleSchoolsAccess"
        (studentsTableFiltersChange)="studentsTableFiltersChange($event)"
        (assessmentResultsMarkChange)="assessmentResultsMarkChange($event)">
      </curr-school-statistic-school-admin>

      <curr-school-statistic-super-admin
        *ngIf="hasMultipleSchoolsAccess"
        (studentsTableFiltersChange)="studentsTableFiltersChange($event)"
        (assessmentResultsMarkChange)="assessmentResultsMarkChange($event)">
      </curr-school-statistic-super-admin>
    </div>
  </div>

  <div class="tabs-list" *ngIf="showTabs; else elseBlock">
    <mat-tab-group
      [dynamicHeight]="true"
      animationDuration="0ms"
      class="nav-panel tab-element custom-ink-size"
    >
      <mat-tab label="Teachers Statistic">
        <ng-template matTabContent>
          <div class="tab-content">
            <curr-teachers-statistic-table
              [averageBenchmark]="chartAverageBenchmark"
              [selectedCourseId]="preselectedCourseId">
            </curr-teachers-statistic-table>
          </div>
        </ng-template>
      </mat-tab>

      <mat-tab label="Students Statistic">
        <ng-template matTabContent>
          <div class="tab-content">
            <curr-students-statistic-table
              [showFullList]="true"
              [averageBenchmark]="chartAverageBenchmark"
              [filtersData]="studentsTableFilters">
            </curr-students-statistic-table>
          </div>
        </ng-template>
      </mat-tab>
    </mat-tab-group>
  </div>

  <ng-template #elseBlock>
    <ng-container>
      <div class="dashboard-outside-title">
        <div class="title-text">Teachers Statistic</div>
      </div>
      <div class="dashboard-section">
        <curr-teachers-statistic-table [averageBenchmark]="chartAverageBenchmark" [selectedCourseId]="preselectedCourseId"></curr-teachers-statistic-table>
      </div>
    </ng-container>
  </ng-template>
</div>
